
document.addEventListener('DOMContentLoaded', function () {
    const input = document.querySelector('#searchFormSubmit input#query');
    const results = document.getElementById('SearchResults');

    input.addEventListener('input', function () {
        const query = input.value.trim();

        if (query.length < 2) {
        results.innerHTML = '';
        return;
        }

        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection`)
        .then(res => res.json())
        .then(data => {
            const collections = data.resources.results.collections;
            if (collections.length) {
            results.innerHTML = collections.map(collection => `
                <div class="suggestion">
                <a href="${collection.url}">
                    <img src="${collection.featured_image}" width="40" height="40" alt="${collection.title}">
                    ${collection.title}
                </a>
                </div>
            `).join('');
            } else {
            results.innerHTML = '<p>No matches</p>';
            }
        });
    });
});      
